import msgIcon1 from "../../../../assets/images/svg/msg_icon-1.svg";

const DefaultRenderer = ({ notification, classes }) => (
  <div className={classes.msgItem} key={`${notification.id}-${notification.timestamp}`}>
    <img src={msgIcon1} alt="msgIcon" />
    <div className={classes.wrapText}>{notification.action}</div>
  </div>
);

export default DefaultRenderer;
